<sim-basic-material-dialog
	(closeClicked)="close()"
	[headerIcon]="{fontIcon: 'fa-users', fontSet: 'fas'}"
	[headerText]="T.ADD_GROUP_MEMBERS_DIALOG_HEADER | translate"
>
	<ng-container dialogContent>
		<form #formEl (ngSubmit)="doSubmit()">
			<mat-form-field color="accent">
				<mat-label>
					<mat-icon fontIcon="fa-object-group" fontSet="fas" inline />
					{{ T.ADD_GROUP_MEMBERS_DIALOG_SELECT_SUBGROUP | translate }}
				</mat-label>
				<mat-select [formControl]="form.controls.assignedGroupId">
					@if (selectedSubgroup()) {
						<mat-select-trigger>
							<ng-container *ngTemplateOutlet="subgroupListItem; context: {$implicit: selectedSubgroup()}" />
						</mat-select-trigger>
					}
					<mat-option [value]="data.parentGroup.id">
						<span class="secondary">{{ T.LABEL_NONE | translate }}</span>
					</mat-option>
					@for (subgroup of subgroups(); track subgroup.id) {
						<mat-option [value]="subgroup.id">
							<ng-container *ngTemplateOutlet="subgroupListItem; context: {$implicit: subgroup}" />
						</mat-option>
					}
				</mat-select>
				<mat-hint class="secondary">
					{{ T.ADD_GROUP_MEMBERS_DIALOG_SELECT_SUBGROUP_HINT | translate }}
				</mat-hint>
			</mat-form-field>

			<sim-autocomplete
				(onSelect)="addMember($event)"
				[dataType]="FetchDataType.SimUser"
				[excludeIds]="excludeIds()"
				[labelToken]="T.BUTTON_ADD"
			>
				<mat-icon fontIcon="fa-user" fontSet="fas" labelPrefix />
			</sim-autocomplete>

			<div class="participantList">
				@if (form.value.members.length > 0) {
					<mat-divider />
					<label class="listHeading secondary">
						<mat-icon fontSet="far" fontIcon="fa-users" inline />
						{{ form.value.members.length }} {{ T.GROUP_MANAGER_PAGE_GROUP_MEMBERS | translate }}
					</label>
					<div class="scrollViewport">
						@for (member of form.value.members; track member.id) {
							<sim-user-list-item
								[showOnClickDialog]="false"
								[user]="member"
								[deletable]="true"
								(onDelete)="removeMember(member)"
							/>
						}
					</div>
				}
			</div>

			<button #submit [appFocus]="false" hidden type="submit"></button>
		</form>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="submit.click()"
			[appBusy]="promise"
			[appFocus]="true"
			[disabled]="!form.value.members.length"
			[icon]="{fontIcon: 'fa-plus', fontSet: 'far'}"
			[label]="T.BUTTON_ADD"
		/>
	</ng-container>
</sim-basic-material-dialog>

<!--TEMPLATE-->
<ng-template #subgroupListItem let-subgroup>
	<div class="subgroupListItem">
		<div class="indicator" [ngClass]="CustomColorMapping[subgroup.color]">
			{{ subgroup.name?.substring(0, 2) }}
		</div>
		<div class="labelWrapper">
			<span>{{ subgroup.name | translate }}</span>
			<span class="secondary"> {{ subgroup.memberIds?.length ?? 0 }} {{ T.GROUP_MANAGER_PAGE_GROUP_MEMBERS | translate }} </span>
		</div>
	</div>
</ng-template>
